import React, { useState, useEffect } from 'react';
import { Modal, Spinner, ToggleButton, ToggleButtonGroup, Alert } from 'react-bootstrap';
import '../../../../styles/RegDashboard.css';
import { HHIEButton } from '../../../utility/HHIEButton';

export function DSAModal(props) {
    const [members, setMembers] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [successAlert, setSuccessAlert] = useState(false);

    useEffect(() => {
        if (props.members) {
            let tempMembers = props.members.filter(member => {
                if (member.registrationComplete && !member.processing)
                    return true;
                else return false;
            })

            setMembers(tempMembers);
        }
    }, [props]);


    const Submit = () => {
        setSubmitting(true);
        const formData = new FormData();
        formData.append("sfid", selectedMember.id);
        formData.append("firstName", selectedMember.firstName);
        formData.append("middleName", selectedMember.middleName);
        formData.append("lastName", selectedMember.lastName);
        formData.append("userIsPOC", props.user.isPOCUser);
        formData.append("userSfid", props.user.sfid);
        formData.append("acctId", props.account.id);
        formData.append("acctName", props.account.legalName);

        const requestOptions = {
            method: 'POST',
            body: formData
        }
        fetch('api/registration/submit-DSA-change-request', requestOptions)
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        if (json.message === true) {
                            setSuccessAlert(true);
                            let tempAcct = props.account;
                            tempAcct.dsaChangeRequested = true;
                            props.setAccount(tempAcct);
                            props.setCanChangeDSA(false)
                        }
                        else {
                            setSuccessAlert(false);
                        }
                        setShowAlert(true);
                        setSubmitting(false);
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
            })
    }

    const ChangeMember = (id) => {
        for (var i = 0; i < members.length; i++) {
            if (members[i].id === id) {
                setSelectedMember(members[i]);
                break;
            }
        }
    }

    return (
        <>
            {(props.show) &&
                <>
                
                    <Modal
                        show={props.show}
                        centered
                        onHide={() => { props.setShow(false); setShowAlert(false); setSuccessAlert(false); }}
                    >
                        <Modal.Header className="d-flex justify-content-center" closeButton>
                            <Modal.Title className="d-flex justify-content-center">
                                Select a member to make Designated Signing Authority.
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                Please note only submitted members with no processing changes can be selected
                            </div>
                        </Modal.Body>
                        <Modal.Body>
                            <div className="d-flex justify-content-center">
                                {members ?
                                    <ToggleButtonGroup
                                        className="mb-2"
                                        type="radio"
                                        name="members-radio"
                                        vertical
                                    >
                                        {members.map((member, idx) => {
                                            return (
                                                <ToggleButton
                                                    id={"Member" + idx}
                                                    key={"Member" + idx}
                                                    type="radio"
                                                    variant="light"
                                                    checked={selectedMember && selectedMember.id === member.id}
                                                    value={member.id}
                                                    onChange={(e) => { ChangeMember(e.target.value); }}
                                                >
                                                    {member.firstName} {member.middleName} {member.lastName}
                                                </ToggleButton>
                                            )
                                        })}
                                    </ToggleButtonGroup>
                                    : <></>
                                }
                            </div>
                        </Modal.Body>
                        <Modal.Footer> 
                            {/* Deleted Rows and Columns due to their flex box centering issues, added a NOT show Alert rendering attribute for the submit button. */}
                            <div
                                style={{
                                    textAlign: 'center'
                                    ,margin: 'auto'
                                }}
                            >
                                    {!showAlert && 
                                        <HHIEButton 
                                            id="dsa-submit" 
                                            disabled={!selectedMember || submitting || (showAlert && successAlert)} 
                                            onClick={() => { Submit() }}
                                            title={!submitting ? "Submit Request" : <Spinner animation="border" />}
                                        />
                                    }
                                    {showAlert && successAlert &&
                                        <Alert id="dsa-submit-alert" variant="success">Your request has been successfully submitted</Alert>
                                    }
                                    {showAlert && !successAlert &&
                                        <Alert id="dsa-submit-alert" variant="danger">Unfortunately something went wrong while submitting. Please try again, or contact the HHIE directly.</Alert>
                                    }
                            </div>
                        </Modal.Footer>
                    </Modal>
                </>
            }
        </>
    );
}
